/**
 * Let the browser resolve each paragraph from its first strong Unicode character.
 * Only presentation attributes change: text nodes, selection and stored/sanitized HTML stay intact.
 */
export function autoNotesDirection(root) {
  if (!root) return;
  root.setAttribute('dir', 'auto');
  root.querySelectorAll('p, div, li, ul, ol, blockquote, h1, h2, h3').forEach((block) => {
    block.setAttribute('dir', 'auto');
  });
}
